import { IEmoji, getEmojiImgUrl } from '@quicktools/emojis';
import { clipboardWrite } from '@quicktools/shared-components/utils/text/clipboard';
import useSnackbarStore from '@quicktools/shared-components/hooks/snackbar';
import { Tooltip } from '@quicktools/shared-components';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { useCallback, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { isMobileOnly } from 'react-device-detect';

import analytics from '../../services/analytics';

import useStyles from './style-emoji';
import { IEmojiItem } from './types';

function Emoji({ emoji, deviceType, click, hover, displayTooltip = false }: IEmojiItem) {
  const styles = useStyles();
  const { t } = useTranslation();
  const [showCopiedTooltip, setShowCopiedTooltip] = useState(false);
  const [showCopyTooltip, setShowCopyTooltip] = useState(false);
  const snackbarShowWarning = useSnackbarStore((state) => state.snackbarShowWarning);
  const { isNew } = emoji;

  const handleClick = useCallback(
    async (e: IEmoji) => {
      click(e);
      setShowCopyTooltip(false);

      try {
        await clipboardWrite(emoji.value);
        setShowCopiedTooltip(true);
        setTimeout(() => {
          setShowCopiedTooltip(false);
        }, 700);
      } catch (err) {
        snackbarShowWarning(t('error.clipboardCopy'));
        console.warn(e);
      }
      analytics.emojiCopy(emoji.group, emoji.name);
    },
    [click],
  );

  const handleMouseEnter = useCallback(() => {
    hover();
    !isMobileOnly && setShowCopyTooltip(true);
  }, [hover]);

  const handleMouseLeave = useCallback(() => {
    setShowCopyTooltip(false);
  }, []);

  return (
    <li
      className={styles.emoji}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={() => handleClick(emoji)}
      title={emoji.shortName}
    >
      <div className={styles.emojiContent}>
        {displayTooltip && showCopyTooltip && (
          <Tooltip className={classNames(styles.tooltip, styles.tooltipCopy)}>
            Click to copy!
          </Tooltip>
        )}

        {showCopiedTooltip && (
          <Tooltip className={classNames(styles.tooltip, styles.tooltipCopied)} color="magenta">
            Copied!
          </Tooltip>
        )}
        <div>
          {deviceType === 'default' ? (
            emoji.value
          ) : (
            <LazyLoadImage
              className={styles.emojiImg}
              src={getEmojiImgUrl(emoji.name, deviceType, '/')}
              alt={emoji.name}
            />
          )}
        </div>
      </div>
      {isNew && <span className={styles.newTag}>New</span>}
    </li>
  );
}

export default Emoji;
